import axios from 'axios';

import config from '../config/config';
import type { Iinventory } from '../types/inventory';

const getInventory = async (storeId: string, productId: string): Promise<Iinventory[]> => {
  try {
    const response = await axios({
      method: 'get',
      url: `${config.inventory.url}/api/inventory/store/${storeId}/product/${productId}`
    });
    return response?.data?.data || [];
  } catch (err) {
    console.error(err);
    return [];
  }
};

export default getInventory;
